// Module
var code = "<matrix-nodes></matrix-nodes>\n";
// Exports
module.exports = code;